/**
 * Run `tick` every `ms` while the page is visible. A tab in the background,
 * or a phone with the app put away, asks nothing; coming back runs a tick at
 * once. Every answer the server sends out counts against its free gigabyte
 * a month, and an app left open all day was most of what it sent.
 */
export function pollWhileVisible(tick: () => void, ms: number): () => void {
  let timer: number | null = null;
  const start = (): void => {
    if (timer !== null) return;
    timer = window.setInterval(tick, ms);
  };
  const stop = (): void => {
    if (timer === null) return;
    window.clearInterval(timer);
    timer = null;
  };
  const onVisibility = (): void => {
    if (document.visibilityState === 'visible') {
      tick();
      start();
    } else stop();
  };
  if (document.visibilityState === 'visible') start();
  document.addEventListener('visibilitychange', onVisibility);
  return () => {
    stop();
    document.removeEventListener('visibilitychange', onVisibility);
  };
}
